module.exports = __webpack_public_path__ + "img/socials_3.7541e3c5.png";